// import { Button, Tooltip, primary2 } from "@shane-collective/design-system";
import { primary2 } from "@shane-collective/design-system";
import { CenterMapIcon } from "@shane-collective/design-system/dist/icons/CenterMapIcon";
import mapboxgl from "mapbox-gl";
import { createRoot } from "react-dom/client";
// import { createRoot } from "react-dom/client";
// import { userMarkerColor } from "../const";

export const loadMapControls = (
  map: mapboxgl.Map
  // onSettingsClick: () => void,
  // onHelpClick: () => void,
  // onCenterClick: () => void
) => {
  // let centering = false
  //hide some attributions bits
  document.querySelectorAll(".mapboxgl-ctrl-bottom-left")[0].remove();
  document.querySelectorAll(".mapbox-improve-map")[0].remove();
  // document.querySelectorAll(".mapboxgl-ctrl-attrib")[0].remove();

  //show controls on map
  map.addControl(new mapboxgl.NavigationControl(), "top-right");

  //get controls component so we can add stuff to to
  const bottomRightElement = document.querySelectorAll(
    ".mapboxgl-ctrl-top-right"
  )[0].children[0];

  (
    document.querySelectorAll(".mapboxgl-ctrl-zoom-in")[0] as HTMLButtonElement
  ).style.margin = "7px";
  (
    document.querySelectorAll(".mapboxgl-ctrl-compass")[0] as HTMLButtonElement
  ).style.margin = "7px";
  (
    document.querySelectorAll(".mapboxgl-ctrl-zoom-out")[0] as HTMLButtonElement
  ).style.margin = "7px";

  //create center button and add to component
  const centerButtonDiv = document.createElement("div");
  bottomRightElement.appendChild(centerButtonDiv);

  centerButtonDiv.style.borderTopColor = "rgb(221, 221, 221)";
  centerButtonDiv.style.borderTopStyle = "solid";
  centerButtonDiv.style.borderTopWidth = "1px";
  centerButtonDiv.style.justifyContent = "center";
  centerButtonDiv.style.alignItems = "center";

  const centerRoot = createRoot(centerButtonDiv);
  centerRoot.render(
    // <Tooltip
    //   label="Center map"
    //   placement="left"
    //   Component={
    <div
      id="centerButton"
      onClick={(e: any) => {
        e.stopPropagation();

        // center map on user
        const queryParams = new URLSearchParams(window.location.search);
        const userLat = queryParams.get("lat");
        const userLng = queryParams.get("lng");

        if (userLat && userLng && map) {
          map.panTo([parseFloat(userLng), parseFloat(userLat)]);
        }
      }}
      style={{
        zIndex: 99999,
        display: "flex",
        height: "44px",
        width: "44px",
        alignItems: "center",
        justifyContent: "center",
      }}
      // zIndex="99999"
      // display="flex"
      // borderWidth={0}
      // iconName="CenterMapIcon"
      // iconWidth="20px"
      // aria-label="Center"
      // iconColor={primary2}
      // role="button"
      // minHeight="44px"
      // minWidth="44px"
    >
      {/* @ts-ignore */}
      <CenterMapIcon color={primary2} width={20} />
    </div>
    //   }
    // />
  );

  //create settings button and add to component
  /*const settingsButtonDiv = document.createElement("div");
  bottomRightElement.appendChild(settingsButtonDiv);

  settingsButtonDiv.style.borderTopColor = "rgb(221, 221, 221)";
  settingsButtonDiv.style.borderTopStyle = "solid";
  settingsButtonDiv.style.borderTopWidth = "1px";
  settingsButtonDiv.style.justifyContent = "center";
  settingsButtonDiv.style.alignItems = "center";

  const root = createRoot(settingsButtonDiv);
  root.render(
    <Tooltip
      label="Settings"
      placement="left"
      Component={
        <Button
          type="secondary_icon"
          onPress={() => onSettingsClick()}
          zIndex="99999"
          display="flex"
          borderWidth={0}
          iconName="SettingsIcon"
          iconWidth="20px"
          aria-label="Settings"
          iconColor={primary2}
          role="button"
          minHeight="44px"
          minWidth="44px"
        />
      }
    />
  );

  //create faq button and add to component
  const faqButtonDiv = document.createElement("div");
  bottomRightElement.appendChild(faqButtonDiv);

  faqButtonDiv.style.borderTopColor = "rgb(221, 221, 221)";
  faqButtonDiv.style.borderTopStyle = "solid";
  faqButtonDiv.style.borderTopWidth = "1px";
  faqButtonDiv.style.justifyContent = "center";
  faqButtonDiv.style.alignItems = "center";

  const rootFaq = createRoot(faqButtonDiv);
  rootFaq.render(
    <Tooltip
      label="Help"
      placement="left"
      Component={
        <Button
          type="secondary_icon"
          onPress={() => onHelpClick()}
          zIndex="99999"
          display="flex"
          borderWidth={0}
          iconName="FaqIcon"
          iconWidth="20px"
          aria-label="FAQ"
          iconColor={primary2}
          role="link"
          minHeight="44px"
          minWidth="44px"
        />
      }
    />
  );*/
};

export const moveBottomRightControls = (type : string) => {
  const bottomRightElement = document.querySelectorAll(
    ".mapboxgl-ctrl-top-right"
  )[0] as HTMLDivElement;

  if (!bottomRightElement) return;

  bottomRightElement.style.top = //type === 'list' ? "70px" : 
  "35px";
};
